<template>

  <nav id="primary-nav" class="navbar fixed-top">

    <div class="container-fluid">
      <div class="d-flex w-100 align-items-center justify-content-between">
        <div class="col">
          <router-link class="" to="/home" @click="scrollPage" v-on:dblclick="updateFiles">
            <img :src="`${publicPath}images/maiora-logo-blue.png`" class="content__logo" alt="Maiora" />
          </router-link>
        </div>
        <div class="col-auto">
          <div class="me-auto mb-2 mb-lg-0">
            <router-link to="/company" @click="scrollPage" class="btn d-none d-lg-inline-block">
              The Brand
            </router-link>
            <button class="btn" type="button" data-bs-toggle="collapse" data-bs-target="#navbarRange" aria-controls="navbarRange" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon d-lg-none"></span>
              <span class="d-none d-lg-block text-uppercase">
                Range 
              </span>
            </button>
            <button type="button" class="btn btn-home d-none d-lg-inline-block" @click="goBack">
              <img src="@/assets/home-black.svg" class="icon-home" alt="Exit" />
            </button>
          </div>
        </div>
      </div>
      <div class="collapse w-100 text-center" id="navbarRange">
        <div class="row align-items-start justify-content-around">
          <div class="col-12 col-lg-auto d-lg-none border-bottom">
            <router-link to="/company" class="btn">
              The Brand
            </router-link>
          </div>
          <div class="col-12 col-lg-auto d-lg-none border-bottom">
            <div class="btn-title">
              Range:
            </div>
          </div>
          <div class="col-12 col-lg-auto" v-for="item in gamma" :key="item.id">
            <button
              :class="['btn', ((item.profile) ? 'btn-image' : '')]" 
              :style="((item.profile) ? 'background-image: url('+ item.profile +')' : '')" 
              @click="(item.children) ? collapse(item.id) : goToPage(item.id)"
            >
              <span>{{ item.title }}</span>
            </button>
            <div v-if="item.children" :id="'collapse-'+ item.id" class="collapse submenu">
              <div class="row justify-content-around">
                <div class="col-12 col-lg-auto">
                  <button class="btn d-inline-block" @click="goToPage(item.id)">
                    <span>{{ item.title }}</span>
                  </button>
                </div>
                <div class="col-12 col-lg-auto" v-for="child in item.children" :key="child.id">
                  <button class="btn d-inline-block" @click="goToPage(child.id)">
                    <span>{{ child.title }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 border-top border-bottom d-lg-none">
            <button type="button" class="btn" @click="goBack">
              <span class="">Esc</span>
            </button>
          </div>
        </div>
      </div>
    </div>

  </nav>

</template>

<script>
  export default {
    name: 'HeaderAbyachts',
    props: ['gamma'],
    emits: ['updateFiles', 'goToPage', 'collapse'],
    data () {
      return {
        publicPath: process.env.BASE_URL
      }
    },
    methods: {
      updateFiles() {
        this.$emit('updateFiles')
      },
      goBack() {
        this.$store.dispatch('setSection', null)
      },
      goToPage(id) {
        this.$emit('goToPage', id)
      },
      collapse(id) {
        this.$emit('collapse', id)
      },
      scrollPage() {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant'
        })
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page__header {
  background-color: var(--main-bg-color);
  color: #000;
}

.content__logo {
  width: 140px;
  display: block;
  margin: 16px 10px;
}

.border-top {
  border-top: 1px solid var(--color-avorio) !important;
}
.border-bottom {
  border-bottom: 1px solid var(--color-avorio) !important;
}

.navbar,
.navbar-toggler {
  font-family: var(--main-font-family);
  font-size: var(--menu-font-size);
  background-color: var(--color-sabbia);
  color: #000;
  line-height: 24px;
}

.navbar .btn {
  font-family: var(--main-font-family);
  font-size: var(--menu-font-size);
  background-color: var(--color-sabbia);
  color: #000;
  line-height: 26px;
  margin: 8px auto;
}

.navbar .submenu-item {
  width: 100%;
}

.navbar .btn-image {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  padding-top: 0;
  padding-bottom: 0;
}

.navbar .btn-image span {
  opacity: 0;
}

.navbar .icon-home {
  width: 24px;
}

.navbar .btn.btn-home {
  margin: 8px 22px 11px;
}

.navbar .submenu > div {
  border-top: 1px solid var(--color-avorio);
  border-bottom: 1px solid var(--color-avorio);
}

@media screen and (min-width:992px) {
  .navbar .btn:not(.btn-home) {
    border-bottom: 1px solid var(--color-avorio) !important;
    border-radius: 0;
    font-size: 18px;
    margin: 8px 22px 12px;
  }
  .navbar .btn:not(.btn-image) {
    padding: 0;
  }
  .navbar .submenu {
    width: 100%;
    position: absolute;
    left: 0;
    background-color: var(--color-sabbia);
  }
  .navbar .submenu > div {
    margin: 0 calc(var(--bs-gutter-x) * .5);
  }

  .content__logo {
    width: 145px;
    margin: 24px;
  }
  .navbar-toggler {
    padding: 0.375rem 0.75rem;
    display: inline-block !important;
    border: 1px solid transparent;
    position: relative;
  }
  #navbarRange {
    border-top: 1px solid var(--color-avorio);
    border-bottom: 1px solid var(--color-avorio); /* */
  }
}

</style>
